<template>
  <v-card :loading="loading">
    <v-card-title class="px-6">
      <v-col cols="12 d-flex justify-center align-center font-weight-medium text-h2">
        <span class="">
          {{ translations.notificationChannels[lang] }}
        </span>
      </v-col>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-row>
      <v-col cols="12" md="12" class="">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="height: 1px"></th>
                <th class="text-left" style="height: 1px"></th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr>
                <td>
                  {{ translations.notificationTypeTitle[lang] }}
                </td>
                <td v-if="campaign.notifier_type == 'priority'">
                  {{ translations.prioritySendTitle[lang] }}
                </td>
                <td v-else>
                  {{ translations.allChannelSendTitle[lang] }}
                </td>
              </tr>

              <tr>
                <td style="width: 50%">
                  {{ translations.overrideText[lang] }}
                </td>
                <td>
                  <v-icon
                    v-if="campaign.override_user_notification_settings"
                    v-text="icons.mdiCheckCircle"
                    color="green"
                  ></v-icon>
                  <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table
          v-for="(item, i) in currentNotifications"
          :key="`${item.system_notification_id}-${item.channel}`"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="height: 1px"></th>
                <th class="text-left" style="height: 1px"></th>
              </tr>
            </thead>
            <tbody>
              <!-- <tr></tr> -->

              <tr v-if="item.data.total !== undefined">
                <td style="width: 50%">
                  <span class="font-weight-bold">{{ item.channel.toUpperCase() }}</span
                  >: {{ translations.total[lang] }}
                </td>
                <td>
                  {{ item.data.total }}
                </td>
              </tr>
              <tr v-for="(number, index) in item.data.total_numbers" :key="`${index}-total`">
                <td style="width: 50%">
                  <span class="font-weight-bold">{{ item.channel.toUpperCase() }}</span
                  >: {{ number.status }}
                </td>
                <td>
                  {{ number.count }}
                </td>
              </tr>
              <tr
                v-for="(number, index) in item.data.fallback_total_numbers"
                :key="`${index}-fallback`"
              >
                <td style="width: 50%">
                  <span class="font-weight-bold">{{ 'FALLBACK SMS' }}</span
                  >: {{ number.status }}
                </td>
                <td>
                  {{ number.count }}
                </td>
              </tr>

              <tr v-if="i == currentNotifications.length - 1" style="background: #eaedf1">
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>

      <!-- <v-col cols="12" md="12" class="pa-6" style="background: #eaedf1;"></v-col> -->
    </v-row>

    <v-container fluid>
      <v-col cols="12" md="12" class="d-flex">
        <span class="text-h5 pa-6 pl-12 pt-1">{{ translations.channelData[lang] }}</span>
      </v-col>
      <v-data-iterator :items="currentNotifications" :items-per-page="5" hide-default-footer>
        <template v-slot:header> </template>

        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="(item, i) in props.items"
              :key="`${item.system_notification_id}-${item.channel}-card`"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              :class="[item.data.message.fallback && 'd-flex']"
            >
              <v-card class="ml-1" flat style="min-width: 100%">
                <v-icon
                  v-if="i && campaign.notifier_type && campaign.notifier_type == 'priority'"
                  size="35"
                  v-text="icons.mdiArrowRight"
                  color="secondary"
                  class="mr-1"
                  style="position: absolute; z-index: 10; top: 15px; left: -31px"
                ></v-icon>
                <v-card-title
                  class="subheading font-weight-bold d-flex justify-center"
                  style="flex-wrap: nowrap"
                  :style="{
                    'border-right': !item.data.message.fallback && ' #eaedf1 1px solid',
                  }"
                >
                  <Icon
                    v-if="item.channel == 'viber'"
                    icon="simple-icons:viber"
                    color="secondary"
                    :style="{
                      fontSize: '35px',
                    }"
                  />
                  <v-icon
                    v-else
                    v-text="item.icon"
                    size="35"
                    color="secondary"
                    class="flex-grow-0 flex-shrink-0"
                  ></v-icon>
                  <div
                    style="min-width: 100px; max-width: 100%"
                    class="flex-grow-1 flex-shrink-0 text-center"
                  >
                    <span style="margin-left: -35px">{{
                      item.channel == 'mail' ? 'email' : item.channel
                    }}</span>
                  </div>
                  <v-tooltip v-if="showEditButton" color="secondary" top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        v-text="icons.mdiPlaylistEdit"
                        size="28"
                        style="cursor: pointer"
                        class="flex-grow-0 flex-shrink-0"
                        @click="openEditDialog(item)"
                      ></v-icon>
                    </template>
                    <span class="font-weight-bold">{{ translations.edit[lang] }}</span>
                  </v-tooltip>
                </v-card-title>

                <v-divider></v-divider>
                <v-list dense style="width: 100%; z-index: 4; position: relative">
                  <img
                    style="
                      width: 100%;
                      z-index: 1;
                      position: absolute;
                      height: 100%;
                      padding-bottom: 16px;
                      padding-top: 1%;
                    "
                    aspect-ratio="16/9"
                    cover
                    src="@/assets/notifications/phone-6064855_1280.webp"
                  />

                  <div v-if="item.channel == 'viber'">
                    <img
                      style="width: 100%; border-radius: 30px; padding: 3%; margin-top: 1.6%"
                      aspect-ratio="16/9"
                      cover
                      src="@/assets/notifications/Screenshot_20230817_123725_Viber.jpg"
                    />

                    <img
                      :src="logo"
                      style="
                        height: 3.2%;
                        width: 6.5%;
                        position: absolute;
                        top: 18.2%;
                        left: 5.8%;
                        border-radius: 33px;
                      "
                    />
                    <v-col
                      style="
                        position: absolute;
                        top: 18.2%;
                        left: 14.3%;
                        background: #20252a;
                        width: 65%;
                        color: white;
                      "
                      class="rounded-lg rounded-tl-0 text-subtitle-2 font-weight-medium pa-0"
                    >
                      <div class="pa-3">
                        <span class="">
                          {{ item.data.message.body[lang] }}
                        </span>
                      </div>
                      <div
                        v-if="item.data.message.image"
                        class=""
                        style="background: rgb(63, 67, 73)"
                      >
                        <div class="pa-2">
                          <img
                            :src="item.data.message.image"
                            style="width: 100%; border-radius: 13px; background: #1c191f"
                          />
                        </div>
                      </div>
                      <div class="pa-3 pt-0 pb-0">
                        <v-col
                          v-if="item.data.message.button[lang]"
                          class="rounded-pill mt-3 pa-1 pl-3 pr-3 text-center font-weight-bold"
                          style="background: #6c5ade; font-size: 12px; line-height: 13px"
                        >
                          {{ item.data.message.button[lang] }}
                        </v-col>

                        <div
                          class="font-weight-thin text-right text-caption pt-1"
                          style="color: rgb(168, 172, 178) !important"
                        >
                          18:03
                        </div>
                      </div>
                    </v-col>
                  </div>

                  <div v-else-if="item.channel == 'push'">
                    <img
                      style="width: 100%; border-radius: 30px; padding: 3%; margin-top: 1.6%"
                      aspect-ratio="16/9"
                      cover
                      src="@/assets/notifications/Screenshot_20230817_124855_One UI Home~2.jpg"
                    />

                    <img
                      :src="logo"
                      style="
                        height: 4.8%;
                        width: 9.5%;
                        position: absolute;
                        top: 49%;
                        left: 8.8%;
                        border-radius: 33px;
                        background: #1c191f;
                        z-index: 4;
                      "
                    />
                    <v-col
                      style="
                        position: absolute;
                        top: 47.2%;
                        left: 5.3%;
                        background: rgb(49, 49, 50);
                        width: 89%;
                        color: white;
                        max-height: 43%;
                        overflow: auto;
                        font-size: 0.7vw !important;
                        line-height: normal;
                        min-height: 7.8%;
                      "
                      class="d-flex flex-column justify-center rounded-lg rounded-tl-0 text-body-2 font-weight-normal pa-0"
                    >
                      <div class="pb-3 pt-1" style="padding-left: 17% !important">
                        <span
                          class="text-subtitle-2 font-weight-bold"
                          style="font-size: 0.88vw !important"
                        >
                          {{ item.data.message.title[lang] }}</span
                        >
                        <div>
                          <span class="">
                            {{ item.data.message.body[lang] }}
                          </span>
                        </div>
                      </div>
                      <div v-if="item.data.message.image" class="pa-2 pt-0">
                        <img
                          :src="item.data.message.image"
                          style="width: 100%; border-radius: 13px; background: #1c191f"
                        />
                      </div>
                      <div class="pa-3 pt-0 pb-0"></div>
                    </v-col>
                  </div>

                  <div v-else-if="item.channel == 'sms'">
                    <img
                      style="width: 100%; border-radius: 30px; padding: 3%; margin-top: 1.6%"
                      aspect-ratio="16/9"
                      cover
                      src="@/assets/notifications/Screenshot_20230817_123530_Messages.jpg"
                    />

                    <v-col
                      style="
                        position: absolute;
                        bottom: 18.6%;
                        left: 6.3%;
                        background: rgb(45, 49, 51);
                        width: 80%;
                        color: white;
                      "
                      class="rounded-lg rounded-tl-0 text-subtitle-2 font-weight-medium pa-0"
                    >
                      <div class="pa-3">
                        <span class="">
                          {{ item.data.message.body[lang] }}
                        </span>
                      </div>
                    </v-col>
                  </div>

                  <div v-else-if="item.channel == 'mail'" style="z-index: 2">
                    <img
                      style="width: 100%; border-radius: 30px; padding: 3%; margin-top: 1.6%"
                      aspect-ratio="16/9"
                      cover
                      src="@/assets/notifications/Screenshot_20240125_144202_Gmail_bg.jpg"
                    />

                    <v-col
                      style="
                        position: absolute;
                        top: 12.6%;
                        left: 5.3%;
                        background: rgb(18, 19, 23);
                        width: 90%;
                        color: white;
                        max-height: 63%;
                        overflow-y: auto;
                        overflow-x: hidden;
                        z-index: 1;
                      "
                      class="text-subtitle-2 font-weight-medium pa-0"
                    >
                      <div>
                        <div class="pa-3">
                          <span class="pa-0 text-h5">
                            {{
                              item.data.message.subject ||
                              (item.data.message.body[lang] &&
                                item.data.message.body[lang].substr(0, 10))
                            }}
                          </span>
                        </div>
                        <img
                          style="width: 100%"
                          class="mt-1 mb-1"
                          aspect-ratio="16/9"
                          cover
                          src="@/assets/notifications/Screenshot_20240125_144202_Gmail_sender.jpg"
                        />
                        <div class="pa-3">
                          <div
                            class="mw-inh"
                            v-html="item.data.message.body[lang] || item.data.message.body"
                          ></div>
                        </div>
                      </div>
                    </v-col>
                  </div>
                </v-list>
              </v-card>
              <v-card
                v-if="item.channel == 'viber' && item.data.message.fallback"
                class="ml-1"
                flat
                style="min-width: 100%"
              >
                <v-icon
                  size="35"
                  v-text="icons.mdiArrowExpandRight"
                  color="secondary"
                  class="mr-1"
                  style="position: absolute; z-index: 10; top: 15px; left: -31px"
                ></v-icon>
                <v-card-title
                  class="subheading font-weight-bold d-flex justify-center"
                  style="flex-wrap: nowrap; border-right: #eaedf1 1px solid"
                >
                  <v-icon
                    v-text="notificationIcons.sms"
                    size="35"
                    color="secondary"
                    class="flex-grow-0 flex-shrink-0"
                  ></v-icon>
                  <div
                    style="min-width: 100px; max-width: 100%"
                    class="flex-grow-1 flex-shrink-0 text-center"
                  >
                    <span style="margin-left: -35px">{{ translations.fallbackSms[lang] }}</span>
                  </div>
                </v-card-title>

                <v-divider></v-divider>

                <v-list dense style="width: 100%; z-index: 4; position: relative">
                  <img
                    style="
                      width: 100%;
                      z-index: 4;
                      position: absolute;
                      height: 100%;
                      padding-bottom: 16px;
                      padding-top: 1%;
                    "
                    aspect-ratio="16/9"
                    cover
                    src="@/assets/notifications/phone-6064855_1280.webp"
                  />
                  <div>
                    <img
                      style="width: 100%; border-radius: 30px; padding: 3%; margin-top: 1.6%"
                      aspect-ratio="16/9"
                      cover
                      src="@/assets/notifications/Screenshot_20230817_123530_Messages.jpg"
                    />

                    <v-col
                      style="
                        position: absolute;
                        bottom: 18.6%;
                        left: 6.3%;
                        background: rgb(45, 49, 51);
                        width: 80%;
                        color: white;
                      "
                      class="rounded-lg rounded-tl-0 text-subtitle-2 font-weight-medium pa-0"
                    >
                      <div class="pa-3">
                        <span class="">
                          {{ item.data.message.sms[lang] }}
                        </span>
                      </div>
                    </v-col>
                  </div>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>

        <template v-slot:footer>
          <v-toolbar class="mt-2" flat>
            <v-toolbar-title class="subheading"> </v-toolbar-title>
          </v-toolbar>
        </template>
      </v-data-iterator>
    </v-container>
    <v-dialog v-model="editDialog" max-width="500">
      <b-card
        v-if="channel"
        type="accept"
        :title="`${translations.edit[lang]} ${channel.system}`"
        :loading="loading"
        :submit-text="translations.submit"
        @cancel="closeEditDialog()"
        @submit="submitNotificationText(channel)"
      >
        <div>
          <b-mentionable
            v-if="!['sms', 'viber'].includes(channel.system)"
            :mentionable-items="mentionableItems"
          >
            <b-text-field
              class="ma-1 ml-0"
              v-model="channel.title[channelLang]"
              :label="translations.channelTitleModal[lang]"
              :success="success.title"
              :error-messages="error.title"
              @focus="error.title = ''"
              @blur="validateTitle"
            >
              <template v-slot:append>
                <b-lang-menu v-model="channelLang" type="inner"></b-lang-menu>
              </template>
            </b-text-field>
          </b-mentionable>
          <b-mentionable :mentionable-items="mentionableItems">
            <b-textarea
              v-model="channel.body[bodyLang]"
              class="ma-1 ml-0"
              color="secondary"
              validate-on-blur
              dense
              clearable
              hide-details="auto"
              outlined
              :isSms="channel.system == 'sms'"
              :label="translations.channelBodyModal[lang]"
              :success="success.body"
              :error-messages="error.body"
              @focus="error.body = ''"
              @blur="validateBody"
            >
              <template v-slot:append>
                <b-lang-menu v-model="bodyLang" type="inner"></b-lang-menu>
              </template>
            </b-textarea>
          </b-mentionable>
        </div>
      </b-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  mdiClose,
  mdiBell,
  mdiCash,
  mdiGift,
  mdiAccount,
  mdiCheckCircle,
  mdiCloseCircle,
  mdiEmailOutline,
  mdiBellOutline,
  mdiMessageTextOutline,
  mdiArrowRight,
  mdiArrowExpandRight,
  mdiPlaylistEdit,
} from '@mdi/js';

import translations from '@/utils/translations/loyaltyPanel/campaigns/viewCampaigns';
import { mapState, mapMutations, mapActions } from 'vuex';
import { Icon } from '@iconify/vue2';
import { cloneDeep } from 'lodash';
import validators from '@/utils/validators/loyaltyPanel/channel';

export default {
  name: 'NotificationInfo',

  mixins: [translations, validators],

  components: {
    Icon,
  },

  data() {
    return {
      icons: {
        mdiClose,
        mdiBell,
        mdiCash,
        mdiGift,
        mdiAccount,
        mdiCheckCircle,
        mdiCloseCircle,
        mdiEmailOutline,
        mdiBellOutline,
        mdiMessageTextOutline,
        mdiArrowRight,
        mdiArrowExpandRight,
        mdiPlaylistEdit,
      },
      onboarding: 0,
      notificationIcons: {
        sms: mdiMessageTextOutline,
        mail: mdiEmailOutline,
        push: mdiBellOutline,
        viber: 'simple-icons:viber',
      },
      editDialog: false,
      channel: null,
      channelLang: this.$route.params.lang,
      bodyLang: this.$route.params.lang,
      changeTitleElAuto: true,
      changeTitleItAuto: true,
      changeTitleEnAuto: true,
      changeBodyElAuto: true,
      changeBodyItAuto: true,
      changeBodyEnAuto: true,
    };
  },

  computed: {
    ...mapState(['loading', 'superUser']),
    ...mapState('loyaltyPanel/campaigns/viewCampaigns', ['campaign', 'systemNotifications']),
    ...mapState('loyaltyPanel/campaigns/newCampaign', ['notificationVariables']),

    lang() {
      return this.$route.params.lang;
    },

    locale() {
      if (this.lang == 'el') return 'el-GR';
      if (this.lang == 'it') return 'it-IT';
      return 'en-GB';
    },

    logo() {
      return this.$store.state.loyaltyPanel.company.logo;
    },

    currentSystemNotifications() {
      const channels = Object.keys(this.campaign?.notifications || {});
      const viberFallback = Boolean(this.campaign?.notifications?.viber?.message?.fallback);
      const idsByChannel = (this.systemNotifications || []).reduce((acc, item) => {
        if (item?.channel) {
          acc[item.channel] = item.system_notification_id;
        }
        return acc;
      }, {});
      return channels
        .filter((channel) => !(viberFallback && channel === 'sms'))
        .map((channel, i) => ({
          channel,
          system_notification_id: idsByChannel[channel] ?? null,
        }));
    },

    currentNotifications() {
      return this.currentSystemNotifications
        .map(({ channel, system_notification_id }) => {
          const channelData = this.campaign?.notifications[channel];
          if (!channel || !channelData || Array.isArray(channelData)) return null;

          const message = channelData?.message;
          if (!message || typeof message !== 'object' || Array.isArray(message)) return null;

          const normalizedMessage = message.body
            ? cloneDeep(message)
            : { body: cloneDeep(message) };

          if (!normalizedMessage?.body) return null;

          normalizedMessage.system = channel;

          return {
            channel,
            system_notification_id,
            data: {
              ...cloneDeep(channelData),
              message: normalizedMessage,
              fallback_total_numbers: normalizedMessage?.fallback
                ? this.campaign?.notifications?.sms?.total_numbers
                : [],
            },
            icon: this.notificationIcons[channel],
          };
        })
        .filter(Boolean);
    },

    showEditButton() {
      return ['running', 'activated', 'user_confirmation', 'pending'].includes(
        this.campaign.status.system
      );
    },

    mentionableItems() {
      return this.notificationVariables.map((e) => ({
        value: e,
        label: this.translations[e]?.lang || e,
      }));
    },
  },
  methods: {
    ...mapActions('loyaltyPanel/campaigns/viewCampaigns', [
      'getCampaignSystemNotifications',
      'updateNotificationText',
    ]),
    ...mapActions('loyaltyPanel/campaigns/newCampaign', ['getNotificationVariables']),
    ...mapMutations(['setNotification']),
    next() {
      this.onboarding = this.onboarding + 1 === this.sections.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.sections.length - 1 : this.onboarding - 1;
    },
    localizeDate(date) {
      return date
        ? new Date(date).toLocaleString(this.locale, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
        : '';
    },
    openEditDialog(item) {
      this.channel = cloneDeep(item.data.message);
      this.editDialog = true;
    },
    closeEditDialog() {
      this.channel = null;
      this.editDialog = false;
    },
    async submitNotificationText() {
      let item = cloneDeep(this.channel.system == 'sms' ? this.channel.body : this.channel);
      item.system = undefined;
      let payload = {
        types: [this.channel.system],
        [this.channel.system]: item,
      };
      let res = await this.updateNotificationText(payload);
      if (res.error === false) {
        let channel = this.currentNotifications.find(
          (x) => x.data.message.system == this.channel.system
        );
        if (channel?.data) {
          channel.data.message = cloneDeep(this.channel);
        }
      }
      this.closeEditDialog();
    },
  },

  watch: {
    ['$route.params.lang'](val) {
      this.channelLang = val;
      this.bodyLang = val;
    },

    ['channel.title']: {
      handler(val) {
        if (val) {
          let langCapital = this.channelLang[0].toUpperCase() + this.channelLang[1];
          if (this.lang == this.channelLang) {
            if (
              this.channelLang != 'el' &&
              this.changeTitleElAuto &&
              this.channel.title.el != this.channel.title[this.channelLang]
            ) {
              this.channel.title.el = this.channel.title[this.channelLang];
            }

            if (
              this.channelLang != 'it' &&
              this.changeTitleItAuto &&
              this.channel.title.it != this.channel.title[this.channelLang]
            ) {
              this.channel.title.it = this.channel.title[this.channelLang];
            }

            if (
              this.channelLang != 'en' &&
              this.changeTitleEnAuto &&
              this.channel.title.en != this.channel.title[this.channelLang]
            ) {
              this.channel.title.en = this.channel.title[this.channelLang];
            }

            this[`changeTitle${langCapital}Auto`] = false;
          } else if (val[this.channelLang] != this.channel.title[this.lang]) {
            this[`changeTitle${langCapital}Auto`] = false;
          }
        }
      },
      deep: true,
    },

    ['channel.body']: {
      handler(val) {
        if (val) {
          let langCapital = this.bodyLang[0].toUpperCase() + this.bodyLang[1];
          if (this.lang == this.bodyLang) {
            if (
              this.bodyLang != 'el' &&
              this.changeBodyElAuto &&
              this.channel.body.el != this.channel.body[this.bodyLang]
            ) {
              this.channel.body.el = this.channel.body[this.bodyLang];
            }

            if (
              this.bodyLang != 'it' &&
              this.changeBodyItAuto &&
              this.channel.body.it != this.channel.body[this.bodyLang]
            ) {
              this.channel.body.it = this.channel.body[this.bodyLang];
            }

            if (
              this.bodyLang != 'en' &&
              this.changeBodyEnAuto &&
              this.channel.body.en != this.channel.body[this.bodyLang]
            ) {
              this.channel.body.en = this.channel.body[this.bodyLang];
            }

            this[`changeBody${langCapital}Auto`] = false;
          } else if (val?.[this.bodyLang] != this.channel.body[this.lang]) {
            this[`changeBody${langCapital}Auto`] = false;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getNotificationVariables();
    if (!this.systemNotifications?.length) {
      this.getCampaignSystemNotifications();
    }
    // if (!this.channel?.channel && this.currentNotifications?.[0]) {
    //     this.channel = this.currentNotifications?.[0]
    // }
  },
};
</script>
<style>
.mw-inh {
  max-width: 100%;
}
.mw-inh .u-row {
  max-width: 100% !important;
}
.mw-inh .u-row .u-col.u-col-100 {
  max-width: 100% !important;
  min-width: 320px !important;
}

table,
tr,
td {
  vertical-align: middle !important;
  border-collapse: collapse;
}
</style>
